/**
 * @file 加载
 * @author caifeng01
 */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import Icon from './icon';
const Loading = ({ prefixCls: customizePrefixCls, loading = true, children, tip = '', indicator, tipPosition = 'bottom', indicatorClassName, size = 'middle' }) => {
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('loading', customizePrefixCls);
    const contextClassname = classNames({
        [`${prefixCls}-loading-context`]: true,
        [`${prefixCls}-bottom`]: tipPosition === 'bottom',
        [`${prefixCls}-zIndex`]: !children
    });
    const iconClassname = classNames({
        [`${prefixCls}-default`]: true,
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small',
        [indicatorClassName]: !!indicatorClassName
    });
    const tipClassname = classNames({
        [`${prefixCls}-tip`]: true,
        [`${prefixCls}-tip-right`]: tipPosition === 'right'
    });
    const childrenClassname = classNames({
        [`${prefixCls}-children`]: loading
    });
    const loadingText = loading && (<div className={contextClassname}>
            {indicator !== null && indicator !== void 0 ? indicator : <Icon prefixCls={prefixCls} className={iconClassname}/>}
            <span className={tipClassname}>{tip}</span>
        </div>);
    return children ? (<div className={`${prefixCls}-loading-wrapper`}>
            <div className={childrenClassname}>{children}</div>
            {loadingText}
        </div>) : loadingText;
};
export default Loading;
